import React from "react";
import { Icon } from "~/components";
import styles from "./Separator.module.css";

export const Separator = () => (
  <li aria-hidden="true" className={styles.separator}>
    <Icon name="arrowRightNoLine" className={styles.separatorIcon} />
  </li>
);
